// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   FaHome,
//   FaFileInvoiceDollar,
//   FaChartBar,
//   FaEllipsisH,
//   FaPlus,
//   FaUsers,
//   FaBox,
//   FaBuilding,
//   FaUniversity,
//   FaMoneyBillWave,
//   FaShoppingCart,
//   FaUndo,
//   FaFileAlt,
//   FaReceipt,
//   FaTruck,
//   FaCog,
//   FaBell,
//   FaBarcode,
//   FaUserTie,
//   FaBoxes,
//   FaChartLine,
// } from "react-icons/fa";

// import "./MobileBottomNav.css";

// const MobileBottomNav = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [showMore, setShowMore] = useState(false);
//   const [showAdd, setShowAdd] = useState(false);

//   const currentPath = location.pathname;

//   /* ================================
//      ACTIVE PAGE
//   ================================= */

//   const isActive = (paths) => {
//     if (Array.isArray(paths)) {
//       return paths.includes(currentPath);
//     }

//     return currentPath === paths;
//   };

//   /* ================================
//      NAVIGATION
//   ================================= */

//   const goTo = (path) => {
//     setShowMore(false);
//     setShowAdd(false);
//     navigate(path);
//   };

//   /* ================================
//      MAIN MORE MENU
//   ================================= */

//   const menuItems = [
//     {
//       key: "overview",
//       label: "Overview",
//       path: "/overview",
//       icon: <FaChartLine />,
//     },
//     {
//       key: "party",
//       label: "Customers",
//       path: "/party",
//       icon: <FaUsers />,
//     },
//     {
//       key: "items",
//       label: "Items",
//       path: "/items",
//       icon: <FaBox />,
//     },
//     {
//       key: "business",
//       label: "Business",
//       path: "/managebussines",
//       icon: <FaBuilding />,
//     },
//     {
//       key: "bank",
//       label: "Bank Account",
//       path: "/bankaccount",
//       icon: <FaUniversity />,
//     },
//     {
//       key: "cash",
//       label: "Cash",
//       path: "/cashinhand",
//       icon: <FaMoneyBillWave />,
//     },
//     {
//       key: "expenses",
//       label: "Expenses",
//       path: "/expenses",
//       icon: <FaMoneyBillWave />,
//     },
//     {
//       key: "purchase",
//       label: "Purchase",
//       path: "/purchase",
//       icon: <FaShoppingCart />,
//     },
//     {
//       key: "purchaseReturn",
//       label: "Purchase Return",
//       path: "/purchaseReturn",
//       icon: <FaUndo />,
//     },
//     {
//       key: "estimate",
//       label: "Estimates",
//       path: "/add-estimate",
//       icon: <FaFileAlt />,
//     },
//     {
//       key: "sale",
//       label: "Sales",
//       path: "/add-sale",
//       icon: <FaReceipt />,
//     },
//     {
//       key: "challan",
//       label: "Challan",
//       path: "/challan-invoice",
//       icon: <FaTruck />,
//     },
//     {
//       key: "services",
//       label: "Services",
//       path: "/services",
//       icon: <FaBoxes />,
//     },
//     {
//       key: "barcode",
//       label: "Barcode",
//       path: "/generatebarcode",
//       icon: <FaBarcode />,
//     },
//     {
//       key: "staff",
//       label: "Staff",
//       path: "/addstaff",
//       icon: <FaUserTie />,
//     },
//     {
//       key: "reports",
//       label: "Reports",
//       path: "/reports",
//       icon: <FaChartBar />,
//     },
//     {
//       key: "notifications",
//       label: "Notifications",
//       path: "/notificaton",
//       icon: <FaBell />,
//     },
//     {
//       key: "settings",
//       label: "Settings",
//       path: "/setting",
//       icon: <FaCog />,
//     },
//   ];

//   /* ================================
//      PLUS MENU
//   ================================= */

//   const addItems = [
//     {
//       label: "New Sale",
//       path: "/add-sale",
//       icon: <FaReceipt />,
//     },
//     {
//       label: "New Purchase",
//       path: "/Addpurchase",
//       icon: <FaShoppingCart />,
//     },
//     {
//       label: "New Estimate",
//       path: "/add-estimate",
//       icon: <FaFileAlt />,
//     },
//     {
//       label: "New Expense",
//       path: "/expenses",
//       icon: <FaMoneyBillWave />,
//     },
//     {
//       label: "New Challan",
//       path: "/challan-invoice",
//       icon: <FaTruck />,
//     },
//     {
//       label: "Add Item",
//       path: "/items",
//       icon: <FaBox />,
//     },
//   ];

//   return (
//     <>
//       {/* ==========================================
//           PLUS ACTION OVERLAY
//       ========================================== */}

//       {showAdd && (
//         <>
//           <div
//             className="mobile-action-overlay"
//             onClick={() => setShowAdd(false)}
//           />

//           <div className="mobile-add-sheet">
//             <div className="mobile-sheet-handle" />

//             <div className="mobile-sheet-header">
//               <div>
//                 <h5>Create New</h5>
//                 <p>Choose what you want to create</p>
//               </div>

//               <button
//                 type="button"
//                 className="mobile-sheet-close"
//                 onClick={() => setShowAdd(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="mobile-add-grid">
//               {addItems.map((item) => (
//                 <button
//                   type="button"
//                   key={item.path}
//                   className="mobile-add-card"
//                   onClick={() => goTo(item.path)}
//                 >
//                   <span className="mobile-add-card-icon">
//                     {item.icon}
//                   </span>

//                   <span className="mobile-add-card-text">
//                     {item.label}
//                   </span>

//                   <span className="mobile-card-arrow">
//                     ›
//                   </span>
//                 </button>
//               ))}
//             </div>
//           </div>
//         </>
//       )}

//       {/* ==========================================
//           MORE OVERLAY
//       ========================================== */}

//       {showMore && (
//         <>
//           <div
//             className="mobile-more-overlay"
//             onClick={() => setShowMore(false)}
//           />

//           <div className="mobile-more-sheet">
//             <div className="mobile-more-handle" />

//             <div className="mobile-more-header">
//               <div>
//                 <h5>All Features</h5>
//                 <span>
//                   Everything you need in one place
//                 </span>
//               </div>

//               <button
//                 type="button"
//                 className="mobile-more-close"
//                 onClick={() => setShowMore(false)}
//               >
//                 ×
//               </button>
//             </div>

//             <div className="mobile-more-grid">
//               {menuItems.map((item) => (
//                 <button
//                   type="button"
//                   key={item.key}
//                   className={`mobile-feature-card ${
//                     isActive(item.path) ? "active" : ""
//                   }`}
//                   onClick={() => goTo(item.path)}
//                 >
//                   <span className="mobile-feature-icon">
//                     {item.icon}
//                   </span>

//                   <span className="mobile-feature-label">
//                     {item.label}
//                   </span>

//                   <span className="mobile-feature-arrow">
//                     ›
//                   </span>
//                 </button>
//               ))}
//             </div>
//           </div>
//         </>
//       )}

//       {/* ==========================================
//           BOTTOM NAVIGATION
//       ========================================== */}

//       <nav className="mobile-bottom-nav">
//         <div className="mobile-bottom-inner">

//           {/* HOME */}
//           <button
//             type="button"
//             className={`mobile-nav-item ${
//               isActive(["/", "/home"])
//                 ? "active"
//                 : ""
//             }`}
//             onClick={() => goTo("/home")}
//           >
//             <span className="mobile-nav-icon">
//               <FaHome />
//             </span>

//             <span className="mobile-nav-label">
//               Home
//             </span>
//           </button>

//           {/* BILLING */}
//           <button
//             type="button"
//             className={`mobile-nav-item ${
//               isActive([
//                 "/add-sale",
//                 "/sale-history",
//                 "/add-estimate",
//                 "/estimate-history",
//                 "/purchase",
//                 "/Addpurchase",
//               ])
//                 ? "active"
//                 : ""
//             }`}
//             onClick={() => goTo("/add-sale")}
//           >
//             <span className="mobile-nav-icon">
//               <FaFileInvoiceDollar />
//             </span>

//             <span className="mobile-nav-label">
//               Billing
//             </span>
//           </button>

//           {/* PLUS */}
//           <div className="mobile-add-wrapper">
//             <button
//               type="button"
//               className={`mobile-add-button ${
//                 showAdd ? "open" : ""
//               }`}
//               onClick={() => {
//                 setShowMore(false);
//                 setShowAdd((prev) => !prev);
//               }}
//               aria-label="Create New"
//             >
//               <FaPlus />
//             </button>
//           </div>

//           {/* REPORTS */}
//           <button
//             type="button"
//             className={`mobile-nav-item ${
//               currentPath.includes("report")
//                 ? "active"
//                 : ""
//             }`}
//             onClick={() => goTo("/reports")}
//           >
//             <span className="mobile-nav-icon">
//               <FaChartBar />
//             </span>

//             <span className="mobile-nav-label">
//               Reports
//             </span>
//           </button>

//           {/* MORE */}
//           <button
//             type="button"
//             className={`mobile-nav-item ${
//               showMore ? "active" : ""
//             }`}
//             onClick={() => {
//               setShowAdd(false);
//               setShowMore((prev) => !prev);
//             }}
//           >
//             <span className="mobile-nav-icon">
//               <FaEllipsisH />
//             </span>

//             <span className="mobile-nav-label">
//               More
//             </span>
//           </button>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default MobileBottomNav;


import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  FaHome,
  FaFileInvoiceDollar,
  FaChartBar,
  FaEllipsisH,
  FaPlus,
  FaUsers,
  FaBox,
  FaBuilding,
  FaUniversity,
  FaMoneyBillWave,
  FaShoppingCart,
  FaUndo,
  FaFileAlt,
  FaReceipt,
  FaTruck,
  FaCog,
  FaBell,
  FaBarcode,
  FaUserTie,
  FaBoxes,
  FaChartLine,
  FaTags,
  FaRupeeSign,
  FaExchangeAlt,
  FaCrown,
} from "react-icons/fa";

import "./MobileBottomNav.css";

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showMore, setShowMore] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  const currentPath = location.pathname;

  /* =====================================================
     NAVIGATION
  ===================================================== */

  const goTo = (path) => {
    setShowMore(false);
    setShowAdd(false);

    navigate(path);
  };

  /* =====================================================
     ACTIVE PAGE
  ===================================================== */

  const isActive = (paths) => {
    if (Array.isArray(paths)) {
      return paths.includes(currentPath);
    }

    return currentPath === paths;
  };

  /* =====================================================
     CREATE NEW MENU
  ===================================================== */

  const addItems = [
    {
      label: "New Sale",
      path: "/add-sale",
      icon: <FaReceipt />,
    },
    {
      label: "New Purchase",
      path: "/Addpurchase",
      icon: <FaShoppingCart />,
    },
    {
      label: "New Estimate",
      path: "/add-estimate",
      icon: <FaFileAlt />,
    },
    {
      label: "New Expense",
      path: "/expenses",
      icon: <FaMoneyBillWave />,
    },
    {
      label: "New Challan",
      path: "/challan-invoice",
      icon: <FaTruck />,
    },
    {
      label: "Add Item",
      path: "/items",
      icon: <FaBox />,
    },
  ];

  /* =====================================================
     ALL FEATURES
  ===================================================== */

  const menuItems = [
    {
      key: "overview",
      label: "Overview",
      path: "/overview",
      icon: <FaChartLine />,
    },
    {
      key: "customers",
      label: "Customers",
      path: "/party",
      icon: <FaUsers />,
    },
    {
      key: "items",
      label: "Items",
      path: "/items",
      icon: <FaBox />,
    },
    {
      key: "business",
      label: "Business",
      path: "/managebussines",
      icon: <FaBuilding />,
    },
    {
      key: "branch",
      label: "Branch",
      path: "/branch",
      icon: <FaBuilding />,
    },
    {
      key: "bank",
      label: "Bank Account",
      path: "/bankaccount",
      icon: <FaUniversity />,
    },
    {
      key: "cash",
      label: "Cash",
      path: "/cashinhand",
      icon: <FaRupeeSign />,
    },
    {
      key: "expenses",
      label: "Expenses",
      path: "/expenses",
      icon: <FaMoneyBillWave />,
    },
    {
      key: "expense-history",
      label: "Expense History",
      path: "/expenseshistory",
      icon: <FaFileAlt />,
    },
    {
      key: "purchase",
      label: "Purchase",
      path: "/purchase",
      icon: <FaShoppingCart />,
    },
    {
      key: "add-purchase",
      label: "Add Purchase",
      path: "/Addpurchase",
      icon: <FaShoppingCart />,
    },
    {
      key: "purchase-return",
      label: "Purchase Return",
      path: "/purchaseReturn",
      icon: <FaUndo />,
    },
    {
      key: "purchase-return-history",
      label: "Purchase Return History",
      path: "/purchase-return-history",
      icon: <FaFileAlt />,
    },
    {
      key: "estimate",
      label: "Estimates",
      path: "/add-estimate",
      icon: <FaFileAlt />,
    },
    {
      key: "estimate-history",
      label: "Estimate History",
      path: "/estimate-history",
      icon: <FaFileAlt />,
    },
    {
      key: "estimate-sale",
      label: "Convert to Sale",
      path: "/estimate-to-sale",
      icon: <FaExchangeAlt />,
    },
    {
      key: "sale",
      label: "Sales",
      path: "/add-sale",
      icon: <FaReceipt />,
    },
    {
      key: "sale-history",
      label: "Sale History",
      path: "/sale-history",
      icon: <FaFileInvoiceDollar />,
    },
    {
      key: "sale-return",
      label: "Sale Return",
      path: "/sale-return",
      icon: <FaUndo />,
    },
    {
      key: "sale-return-history",
      label: "Sale Return History",
      path: "/sale-return-history",
      icon: <FaFileAlt />,
    },
    {
      key: "payment-in",
      label: "Payment In",
      path: "/payment-in-history",
      icon: <FaMoneyBillWave />,
    },
    {
      key: "challan",
      label: "Challan",
      path: "/challan-invoice",
      icon: <FaTruck />,
    },
    {
      key: "challan-list",
      label: "Challan List",
      path: "/challan-list",
      icon: <FaFileAlt />,
    },
    {
      key: "services",
      label: "Services",
      path: "/services",
      icon: <FaBoxes />,
    },
    {
      key: "category",
      label: "Category",
      path: "/category",
      icon: <FaTags />,
    },
    {
      key: "units",
      label: "Units",
      path: "/units",
      icon: <FaBox />,
    },
    {
      key: "barcode",
      label: "Barcode",
      path: "/generatebarcode",
      icon: <FaBarcode />,
    },
    {
      key: "staff",
      label: "Staff",
      path: "/addstaff",
      icon: <FaUserTie />,
    },
    {
      key: "reports",
      label: "Reports",
      path: "/reports",
      icon: <FaChartBar />,
    },
    {
      key: "sales-report",
      label: "Sales Report",
      path: "/salewisereport",
      icon: <FaChartBar />,
    },
    {
      key: "settlement-report",
      label: "Settlement",
      path: "/settlementreport",
      icon: <FaChartBar />,
    },
    {
      key: "tax-report",
      label: "Tax Report",
      path: "/taxreport",
      icon: <FaChartBar />,
    },
    {
      key: "stock-report",
      label: "Stock Report",
      path: "/stokereport",
      icon: <FaBoxes />,
    },
    {
      key: "profit-loss",
      label: "Profit & Loss",
      path: "/profitLossreport",
      icon: <FaChartLine />,
    },
    {
      key: "cheque",
      label: "Cheque",
      path: "/cheque",
      icon: <FaFileInvoiceDollar />,
    },
    {
      key: "loyalty",
      label: "Loyalty Points",
      path: "/loyalitypoints",
      icon: <FaCrown />,
    },
    {
      key: "notifications",
      label: "Notifications",
      path: "/notificaton",
      icon: <FaBell />,
    },
    {
      key: "settings",
      label: "Settings",
      path: "/setting",
      icon: <FaCog />,
    },
    {
      key: "premium",
      label: "Premium",
      path: "/premium",
      icon: <FaCrown />,
    },
  ];

  return (
    <>
      {/* =====================================================
          CREATE NEW BOTTOM SHEET
      ===================================================== */}

      {showAdd && (
        <>
          <div
            className="mobile-action-overlay"
            onClick={() => setShowAdd(false)}
          />

          <div className="mobile-add-sheet">
            <div className="mobile-sheet-handle" />

            <div className="mobile-sheet-header">
              <div>
                <h5>Create New</h5>
                <p>Choose what you want to create</p>
              </div>

              <button
                type="button"
                className="mobile-sheet-close"
                onClick={() => setShowAdd(false)}
              >
                ×
              </button>
            </div>

            <div className="mobile-add-grid">
              {addItems.map((item) => (
                <button
                  type="button"
                  key={item.path}
                  className="mobile-add-card"
                  onClick={() => goTo(item.path)}
                >
                  <span className="mobile-add-card-icon">
                    {item.icon}
                  </span>

                  <span className="mobile-add-card-text">
                    {item.label}
                  </span>

                  <span className="mobile-card-arrow">
                    ›
                  </span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      {/* =====================================================
          MORE BOTTOM SHEET
      ===================================================== */}

      {showMore && (
        <>
          <div
            className="mobile-more-overlay"
            onClick={() => setShowMore(false)}
          />

          <div className="mobile-more-sheet">
            <div className="mobile-more-handle" />

            <div className="mobile-more-header">
              <div>
                <h5>All Features</h5>

                <span>
                  Access all pages from one place
                </span>
              </div>

              <button
                type="button"
                className="mobile-more-close"
                onClick={() => setShowMore(false)}
              >
                ×
              </button>
            </div>

            <div className="mobile-more-grid">
              {menuItems.map((item) => (
                <button
                  type="button"
                  key={item.key}
                  className={`mobile-feature-card ${
                    isActive(item.path) ? "active" : ""
                  }`}
                  onClick={() => goTo(item.path)}
                >
                  <span className="mobile-feature-icon">
                    {item.icon}
                  </span>

                  <span className="mobile-feature-label">
                    {item.label}
                  </span>

                  <span className="mobile-feature-arrow">
                    ›
                  </span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      {/* =====================================================
          MOBILE BOTTOM NAVIGATION
      ===================================================== */}

      <nav className="mobile-bottom-nav">
        <div className="mobile-bottom-inner">

          {/* HOME */}
          <button
            type="button"
            className={`mobile-nav-item ${
              isActive(["/", "/home"])
                ? "active"
                : ""
            }`}
            onClick={() => goTo("/home")}
          >
            <span className="mobile-nav-icon">
              <FaHome />
            </span>

            <span className="mobile-nav-label">
              Home
            </span>
          </button>

          {/* BILLING */}
          <button
            type="button"
            className={`mobile-nav-item ${
              isActive([
                "/add-sale",
                "/sale-history",
                "/sale-return",
                "/purchase",
                "/Addpurchase",
                "/add-estimate",
                "/estimate-history",
              ])
                ? "active"
                : ""
            }`}
            onClick={() => goTo("/add-sale")}
          >
            <span className="mobile-nav-icon">
              <FaFileInvoiceDollar />
            </span>

            <span className="mobile-nav-label">
              Billing
            </span>
          </button>

          {/* CENTER PLUS */}
          <div className="mobile-add-wrapper">
       <button
  type="button"
  className={`mobile-add-button ${
    showAdd ? "open" : ""
  }`}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    setShowMore(false);
    setShowAdd((prev) => !prev);
  }}
  aria-label="Create New"
>
  <FaPlus />
</button>
          </div>

          {/* REPORTS */}
          <button
            type="button"
            className={`mobile-nav-item ${
              currentPath.includes("report")
                ? "active"
                : ""
            }`}
            onClick={() => goTo("/reports")}
          >
            <span className="mobile-nav-icon">
              <FaChartBar />
            </span>

            <span className="mobile-nav-label">
              Reports
            </span>
          </button>

          {/* MORE */}
          <button
            type="button"
            className={`mobile-nav-item ${
              showMore ? "active" : ""
            }`}
            onClick={() => {
              setShowAdd(false);
              setShowMore((prev) => !prev);
            }}
          >
            <span className="mobile-nav-icon">
              <FaEllipsisH />
            </span>

            <span className="mobile-nav-label">
              More
            </span>
          </button>
        </div>
      </nav>
    </>
  );
};

export default MobileBottomNav;